import { render, staticRenderFns } from "./Print2.vue?vue&type=template&id=566386ce&scoped=true"
import script from "./Print2.vue?vue&type=script&lang=js"
export * from "./Print2.vue?vue&type=script&lang=js"
import style0 from "./Print2.vue?vue&type=style&index=0&id=566386ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566386ce",
  null
  
)

export default component.exports